import { Button } from '@picsart/design-system/components/Button';
import { useNavigate } from 'react-router-dom';
import Image from 'components/Image';
import { ItemProps } from './type';

import useStyles from './styles';

export default function Item({ sizeItem }: ItemProps) {
  const classes = useStyles();
  const navigate = useNavigate();
  const { imgSrc, name, slug } = sizeItem;

  const handlerSinglePage = () => {
    navigate(`/${slug}/`);
  };
  return (
    <div className={classes.itemContainer}>
      <div className={classes.wrapper}>
        <Button
          onClick={() => handlerSinglePage()}
          aria-label={`single size page  "${name}"`}
          className={classes.imgContainer}
        >
          <Image src={imgSrc} alt={`size "${name}"`} className={classes.img} />
        </Button>
        <p className={classes.sizeItemName}>{name}</p>
      </div>
    </div>
  );
}
